/* eslint-disable angular/window-service */
const sst = function (event) {
  if (!event) { event = window.event; }
  if (!event.newValue) return;
  if (event.key === 'getSessionStorage') {
    localStorage.setItem('sessionStorage', angular.toJson(sessionStorage));
    localStorage.removeItem('sessionStorage');
  } else if (event.key === 'sessionStorage' && !sessionStorage.length) {
    const data = angular.fromJson(event.newValue);
    Object.keys(data).forEach((key) => {
      sessionStorage.setItem(key, data[key]);
    });
  }
};

if (window.addEventListener) {
  window.addEventListener('storage', sst, false);
} else {
  window.attachEvent('onstorage', sst);
}

if (!sessionStorage.length) {
  localStorage.setItem('getSessionStorage', 'sst');
  localStorage.removeItem('getSessionStorage', 'sst');
}
